import {createSlice} from '@reduxjs/toolkit';
import Banner from '../../models/gallery.model';

interface banner{
  banner:Banner | undefined,
  loading:boolean,
  error:any,
}


const initialState:banner = {
  banner:undefined,
  error:undefined,
  loading:false
} 


const bannerSlice = createSlice({
  name:'banner',
  initialState:initialState,
  reducers:{

    fetchBannerRequest(state){
      state.loading = true;
    },


    fetchBannerSuccess(state,action){
      state.loading = false;
      state.banner = action.payload;
    },


    fetchBannerFail(state,action){
      state.loading = false;
      state.error = action.payload;
    }

  }
});


export const {

  fetchBannerFail,
  fetchBannerRequest,
  fetchBannerSuccess

} = bannerSlice.actions;

export default bannerSlice.reducer;